"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const admin_1 = require("../../shared-types/admin");
const roleSchema = zod_1.z.object({
    roleId: admin_1.RoleDefinitionIDSchema,
    entityId: zod_1.z.string(),
    roleType: admin_1.PermissionEntityTypeSchema,
});
const permissionSchema = zod_1.z.object({
    permissionId: admin_1.PermissionDefinitionIDSchema,
    entityId: zod_1.z.string(),
    permissionType: admin_1.PermissionEntityTypeSchema,
});
exports.requestSchema = zod_1.z.object({
    userIds: zod_1.z.array(zod_1.z.number()),
    roles: zod_1.z
        .object({
        rolesToDelete: zod_1.z.array(roleSchema),
        rolesToCreate: zod_1.z.array(roleSchema),
    })
        .optional()
        .nullable(),
    permissions: zod_1.z
        .object({
        permissionsToDelete: zod_1.z.array(permissionSchema),
        permissionsToCreate: zod_1.z.array(permissionSchema),
    })
        .optional()
        .nullable(),
});
exports.path = '/admin-update-user-permissions';
//# sourceMappingURL=index.js.map